import { Link } from 'react-router-dom';
import { ArrowRight, Camera, Snowflake, ChevronLeft, ChevronRight } from 'lucide-react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/ui/carousel';
import cryoMachine1 from '@/assets/cryo-machine-1.png';
import cryoMachine2 from '@/assets/cryo-machine-2.png';
import cryoMachine3 from '@/assets/cryo-machine-3.png';
import cryoAvantApres1 from '@/assets/cryo-avant-apres-1.png';
import cryoAvantApres2 from '@/assets/cryo-avant-apres-2.png';
import cryoAvantApres3 from '@/assets/cryo-avant-apres-3.png';
import cryoAvantApres4 from '@/assets/cryo-avant-apres-4.png';
import cryoModele from '@/assets/cryo-modele.png';

const allImages = [
  { src: cryoMachine1, alt: 'E-SLIM Cryo 360° — vue de face', caption: 'E-SLIM Cryo 360°' },
  { src: cryoAvantApres1, alt: 'Avant/après — remodelage du dos', caption: 'Avant / Après — Dos' },
  { src: cryoAvantApres2, alt: 'Avant/après — affinement du ventre', caption: 'Avant / Après — Ventre' },
  { src: cryoModele, alt: 'Modèle Body by CC — silhouette sculptée', caption: 'Résultat Body by CC' },
  { src: cryoMachine2, alt: 'E-SLIM Cryo 360° — panneau de contrôle', caption: 'Panneau de contrôle' },
  { src: cryoAvantApres3, alt: 'Avant/après — réduction abdominale homme', caption: 'Avant / Après — Abdomen' },
  { src: cryoAvantApres4, alt: 'Avant/après — silhouette affinée', caption: 'Avant / Après — Silhouette' },
  { src: cryoMachine3, alt: 'E-SLIM Cryo 360° — vue complète', caption: 'Vue complète de la machine' },
];

const CryoShowcase = () => {
  return (
    <section className="px-6 lg:px-8 py-12 md:py-16 bg-secondary/30">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <p className="text-xs font-heading font-medium uppercase tracking-[0.2em] text-accent mb-3 flex items-center justify-center gap-1.5">
            <Snowflake size={13} /> E-SLIM Cryo 360°
          </p>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground">
            Résultats visibles dès la 1ère séance
          </h2>
          <p className="text-sm text-muted-foreground mt-2 max-w-lg mx-auto font-body">
            Notre machine de cryothérapie minceur dernière génération et les résultats obtenus par nos client(e)s.
          </p>
        </div>

        <Carousel
          opts={{ align: 'start', loop: true }}
          className="w-full"
        >
          <CarouselContent className="-ml-4">
            {allImages.map((img, i) => (
              <CarouselItem key={i} className="pl-4 basis-[75%] sm:basis-1/2 md:basis-1/3">
                <div className="rounded-2xl overflow-hidden border border-border bg-card shadow-sm h-full">
                  <div className="aspect-square overflow-hidden bg-secondary/20">
                    <img
                      src={img.src}
                      alt={img.alt}
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-3 text-center">
                    <p className="text-xs font-heading font-semibold text-foreground">{img.caption}</p>
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="flex items-center justify-center gap-3 mt-6">
            <CarouselPrevious className="static translate-y-0 h-9 w-9 border-border" />
            <p className="text-xs text-muted-foreground font-body">
              <Camera size={12} className="inline mr-1 -mt-0.5" />
              Résultats réels — Body by CC Sevran
            </p>
            <CarouselNext className="static translate-y-0 h-9 w-9 border-border" />
          </div>
        </Carousel>

        <div className="text-center mt-6">
          <Link
            to="/soins/cryotherapie"
            onClick={() => window.scrollTo(0, 0)}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary text-primary-foreground font-heading font-medium text-sm hover:bg-primary/90 transition-colors"
          >
            Découvrir l'E-SLIM Cryo 360° <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CryoShowcase;
